/*
  MCK Variant Guard (tema TEST PROVA DAVIDE)
  Obbliga il cliente a scegliere taglia (e colore, se ce n'e piu di uno) prima di aggiungere al carrello.
  Vale per ogni <variant-picker> del tema: pagina prodotto, barra fissa, scelta rapida delle collezioni e del carrello.
  Non cambia la logica del tema: la variante scelta dal tema resta quella che va nel carrello, qui si controlla
  solo che il cliente l'abbia scelta davvero, e si blocca l'invio (anche PayPal / Shop Pay) finche manca qualcosa.
  Gestisce anche la barra fissa "Aggiungi al carrello" su telefono (sposta i pulsanti flottanti sopra la barra).
*/
(function () {
  if (window.__mckVG) return;
  window.__mckVG = true;

  var lang = (document.documentElement.lang || 'it').slice(0, 2);
  var T = {
    it: { size: 'Seleziona taglia', color: 'Seleziona colore', both: 'Seleziona colore e taglia', other: 'Seleziona', msg_size: 'Seleziona la taglia per continuare', msg_color: 'Seleziona il colore per continuare', msg_both: 'Seleziona colore e taglia per continuare', msg_other: 'Seleziona le opzioni per continuare' },
    de: { size: 'Größe wählen', color: 'Farbe wählen', both: 'Farbe und Größe wählen', other: 'Bitte wählen', msg_size: 'Bitte wähle eine Größe', msg_color: 'Bitte wähle eine Farbe', msg_both: 'Bitte wähle Farbe und Größe', msg_other: 'Bitte wähle die Optionen' },
    en: { size: 'Select size', color: 'Select colour', both: 'Select colour and size', other: 'Select', msg_size: 'Please select a size', msg_color: 'Please select a colour', msg_both: 'Please select colour and size', msg_other: 'Please select the options' }
  }[lang] || null;
  if (!T) T = { size: 'Seleziona taglia', color: 'Seleziona colore', both: 'Seleziona colore e taglia', other: 'Seleziona', msg_size: 'Seleziona la taglia per continuare', msg_color: 'Seleziona il colore per continuare', msg_both: 'Seleziona colore e taglia per continuare', msg_other: 'Seleziona le opzioni per continuare' };
  var PLACEHOLDERS = [T.size, T.color, T.other];

  var state = {};
  var auto = false;
  /* MCK 2026-10-23 (Tim/Jason, nessuna vendita dal 22.10.): come nel tema precedente il colore e la taglia mostrati dal
     tema valgono gia come scelti, basta un clic su "Aggiungi al carrello". Per tornare all'obbligo di scelta:
     PRESELECT = {} (oppure solo { color: true } per far scegliere solo la taglia). */
  var PRESELECT = { color: true, size: true, other: true };
  var COLOR_RE = /colou?r|farbe|couleur/i;
  var SIZE_RE = /tagl|size|gr(ö|o)(ß|ss)e|taille/i;

  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  function kind(fs) {
    if (fs.classList.contains('mck-size-picker')) return 'size';
    if (fs.classList.contains('mck-color-picker')) return 'color';
    var l = (fs.querySelector('legend') || {}).textContent || '';
    return SIZE_RE.test(l) ? 'size' : (COLOR_RE.test(l) ? 'color' : 'other');
  }
  function radios(fs) { return fs.querySelectorAll('input[type=radio][data-option-position]'); }
  function posOf(fs) { var i = fs.querySelector('input[data-option-position]'); return i ? i.getAttribute('data-option-position') : null; }
  /* da scegliere solo se ci sono almeno 2 valori selezionabili (un solo colore resta gia scelto) */
  function isRequired(fs) { return radios(fs).length > 1; }
  function S(id) { return state[id] || (state[id] = { chosen: {}, alert: false, init: false, soldout: false, tries: 0 }); }
  function variantOf(vp) {
    var s = vp.querySelector('script[data-variant]');
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  function urlVariant() { try { return new URLSearchParams(location.search).get('variant'); } catch (e) { return null; } }

  function init(vp) {
    var id = vp.getAttribute('form-id'), s = S(id);
    if (s.init) return s;
    s.init = true;
    var v = variantOf(vp), q = urlVariant(), withUrl = vp.hasAttribute('update-url');
    /* prodotto del tutto esaurito: il tema mostra gia "Esaurito", non serve altro */
    s.soldout = !!(v && v.available === false && !(withUrl && q));
    if (withUrl && q) {
      var all = ss('mckvg:' + vp.getAttribute('handle')) === q && v && String(v.id) === q;
      vp.querySelectorAll('fieldset').forEach(function (fs) {
        var p = posOf(fs); if (!p) return;
        /* dopo un aggiornamento della pagina: se la variante nell'indirizzo l'aveva scelta il cliente, resta scelta.
           Un link con ?variant= (es. dal colore scelto in collezione) vale come colore scelto, la taglia no */
        if (all || kind(fs) === 'color') s.chosen[p] = 1;
      });
    }
    vp.querySelectorAll('fieldset').forEach(function (fs) {
      var p = posOf(fs);
      if (p && PRESELECT[kind(fs)]) s.chosen[p] = 1;
    });
    return s;
  }

  function missing(vp) {
    var s = S(vp.getAttribute('form-id')), out = [];
    vp.querySelectorAll('fieldset').forEach(function (fs) {
      var p = posOf(fs);
      if (p && isRequired(fs) && !s.chosen[p]) out.push({ fs: fs, kind: kind(fs) });
    });
    return out;
  }
  function msgFor(list) {
    var k = list.map(function (m) { return m.kind; });
    if (k.indexOf('size') > -1 && k.indexOf('color') > -1) return T.msg_both;
    if (k.length === 1 && k[0] === 'size') return T.msg_size;
    if (k.length === 1 && k[0] === 'color') return T.msg_color;
    return T.msg_other;
  }
  function pickLabel(list) {
    var k = list.map(function (m) { return m.kind; });
    if (k.indexOf('size') > -1 && k.indexOf('color') > -1) return T.both;
    return T[k[0]] || T.other;
  }
  function pickerFor(id) { return document.querySelector('variant-picker[form-id="' + id + '"]'); }
  function lockTargets(id) {
    var f = document.getElementById(id), list = [];
    if (f) list.push(f);
    document.querySelectorAll('buy-buttons[form="' + id + '"]').forEach(function (b) { list.push(b); });
    return list;
  }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  function apply() {
    document.querySelectorAll('variant-picker[form-id]').forEach(function (vp) {
      var id = vp.getAttribute('form-id'), s = init(vp);
      var miss = s.soldout ? [] : missing(vp);
      vp.querySelectorAll('fieldset').forEach(function (fs) {
        var pending = miss.some(function (m) { return m.fs === fs; });
        if (fs.classList.contains('mck-vg-pending') !== pending) fs.classList.toggle('mck-vg-pending', pending);
        var span = fs.querySelector('.variant-picker__option-info span');
        if (pending) setText(span, T[kind(fs)] || T.other);
        else if (span && PLACEHOLDERS.indexOf(span.textContent) > -1) {
          var c = fs.querySelector('input[type=radio]:checked'), l = c && fs.querySelector('label[for="' + c.id + '"]');
          if (l) setText(span, l.textContent.trim());
        }
      });
      var locked = miss.length > 0;
      lockTargets(id).forEach(function (el) {
        if (el.hasAttribute('data-mck-locked') !== locked) { if (locked) el.setAttribute('data-mck-locked', ''); else el.removeAttribute('data-mck-locked'); }
        /* barra fissa: al posto di "Aggiungi al carrello" dice cosa scegliere, e il clic riporta alla scelta */
        if (el.closest('product-quick-add')) {
          var btn = el.querySelector('[type=submit]');
          var pick = btn && btn.querySelector('.mck-qa-pick');
          if (locked && btn) {
            if (!pick) { pick = document.createElement('span'); pick.className = 'mck-qa-pick'; btn.appendChild(pick); }
            setText(pick, pickLabel(miss));
          } else if (pick) pick.remove();
        }
      });
      var msg = vp.querySelector('.mck-vg-msg');
      if (locked && s.alert) {
        if (!msg) { msg = document.createElement('p'); msg.className = 'mck-vg-msg'; msg.setAttribute('role', 'alert'); }
        var anchor = miss[0].fs;
        if (msg.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', msg);
        setText(msg, msgFor(miss));
      } else if (msg) msg.remove();
      if (!locked) {
        s.alert = false;
        if (vp.hasAttribute('update-url')) { var q = urlVariant(); if (q) ss('mckvg:' + vp.getAttribute('handle'), q); }
      } else fixHiddenSoldOut(vp, id, miss, s);
    });
    stickyBar();
  }

  /* Taglia non ancora scelta ma la combinazione nascosta del tema e esaurita (es. dopo aver cambiato colore):
     il pulsante risulterebbe "Esaurito". Si sposta in silenzio su una taglia disponibile, che resta "da scegliere". */
  function fixHiddenSoldOut(vp, id, miss, s) {
    var f = document.getElementById(id), btn = f && f.querySelector('[type=submit]');
    if (!btn || !btn.disabled || s.tries > 2) return;
    for (var i = 0; i < miss.length; i++) {
      var fs = miss[i].fs, inputs = radios(fs);
      for (var j = 0; j < inputs.length; j++) {
        var inp = inputs[j], lab = fs.querySelector('label[for="' + inp.id + '"]');
        if (!inp.checked && !inp.disabled && lab && !lab.classList.contains('is-disabled')) {
          s.tries++; auto = true; inp.checked = true;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
          auto = false; return;
        }
      }
    }
  }

  var timer = 0;
  function schedule() { if (!timer) timer = setTimeout(function () { timer = 0; apply(); }, 30); }

  function choose(input) {
    var id = input.getAttribute('form'), fs = input.closest('fieldset');
    if (!id || !fs) return;
    var s = S(id); s.chosen[input.getAttribute('data-option-position')] = 1; s.tries = 0;
    var span = fs.querySelector('.variant-picker__option-info span'), l = fs.querySelector('label[for="' + input.id + '"]');
    if (span && l) setText(span, l.textContent.trim());
    schedule();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (auto || !t.matches || !t.matches('input[type=radio][data-option-position]')) return;
    choose(t);
  }, true);

  /* clic su un valore gia spuntato dal tema (nessun evento change): vale come scelta */
  document.addEventListener('click', function (e) {
    var l = e.target.closest && e.target.closest('.mck-vg-pending label[for]');
    if (!l) return;
    var i = document.getElementById(l.htmlFor);
    if (i && i.checked) choose(i);
  }, true);

  function block(id, e) {
    var vp = pickerFor(id); if (!vp) return false;
    var s = S(id);
    if (s.soldout || !missing(vp).length) return false;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    s.alert = true; apply();
    vp.classList.remove('mck-vg-shake'); void vp.offsetWidth; vp.classList.add('mck-vg-shake');
    var r = vp.getBoundingClientRect();
    if (r.top < 80 || r.bottom > window.innerHeight - 90) {
      var start = window.scrollY, to = Math.max(0, start + r.top - Math.max(100, (window.innerHeight - r.height) / 2));
      window.scrollTo({ top: to, behavior: 'smooth' });
      setTimeout(function () { if (Math.abs(window.scrollY - start) < 5) window.scrollTo(0, to); }, 450);
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[type=submit], .shopify-payment-button, shopify-buy-it-now-button, shopify-accelerated-checkout, buy-buttons');
    if (!t) return;
    var id = null;
    if (t.form) id = t.form.getAttribute('id'); /* form.id non va: il campo name="id" lo copre */
    if (!id) { var bb = t.closest('buy-buttons[form]'); if (bb) id = bb.getAttribute('form'); }
    if (!id) { var f = t.closest('form'); if (f) id = f.getAttribute('id'); }
    if (id) block(id, e);
  }, true);

  document.addEventListener('submit', function (e) { var id = e.target && e.target.getAttribute && e.target.getAttribute('id'); if (id) block(id, e); }, true);

  /* scelta rapida: ogni apertura riparte da zero */
  document.addEventListener('dialog:after-hide', function (e) {
    var d = e.target;
    if (d && d.tagName === 'QUICK-BUY-DRAWER') Object.keys(state).forEach(function (k) { if (k.indexOf('quick-buy-form-') === 0) delete state[k]; });
  });

  /* ---------- Barra fissa su telefono ---------- */
  var mq = window.matchMedia('(max-width: 699px)');
  function stickyBar() {
    var qa = document.querySelector('product-quick-add.product-quick-add');
    var root = document.documentElement;
    var cookie = document.getElementById('iubenda-cs-banner');
    var cookieOn = !!(cookie && cookie.offsetHeight > 0);
    var on = !!(qa && mq.matches && qa.classList.contains('is-visible') && !cookieOn);
    if (root.classList.contains('mck-qa-on') !== on) root.classList.toggle('mck-qa-on', on);
    if (root.classList.contains('mck-qa-cookie') !== cookieOn) root.classList.toggle('mck-qa-cookie', cookieOn);
    if (on) { var h = qa.offsetHeight + 'px'; if (root.style.getPropertyValue('--mck-qa-h') !== h) root.style.setProperty('--mck-qa-h', h); }
  }

  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      /* il tema aggiorna la scheda prodotto anche solo cambiando classi e testi: si riapplica lo stato */
      if (m.type === 'characterData') { var pe = m.target.parentElement; if (pe && pe.closest('variant-picker')) { schedule(); return; } continue; }
      if (m.type === 'attributes' ? /^(PRODUCT-QUICK-ADD|FIELDSET|BUTTON)$/.test(m.target.tagName) : (m.addedNodes.length || m.removedNodes.length)) { schedule(); return; }
    }
  }).observe(document.body || document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled'] });
  window.addEventListener('resize', schedule, { passive: true });
  apply();
})();
